// extracted by mini-css-extract-plugin
module.exports = {"container":"bXWxWI4NaB-emo+iIkoYUw==","icon":"_4WdBaJB63P6MhimVZTHmOg==","content":"gfIp2UmNry7W3X82KJwNOw=="};